import script from "./ScoreWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreWidget.vue?vue&type=script&setup=true&lang=js"

import "./ScoreWidget.vue?vue&type=style&index=0&id=a9a7cc48&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9a7cc48"]])

export default __exports__